var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E6007A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 18.8714C36.4937 18.8714 40.1366 16.7517 40.1366 14.137C40.1366 11.5222 36.4937 9.40256 32 9.40256C27.5063 9.40256 23.8634 11.5222 23.8634 14.137C23.8634 16.7517 27.5063 18.8714 32 18.8714Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54.5312C36.4937 54.5312 40.1366 52.4115 40.1366 49.7968C40.1366 47.1821 36.4937 45.0624 32 45.0624C27.5063 45.0624 23.8634 47.1821 23.8634 49.7968C23.8634 52.4115 27.5063 54.5312 32 54.5312Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6592 25.4193C22.9061 21.5276 22.8918 17.3129 20.6274 16.0055C18.363 14.6982 14.7059 16.7932 12.459 20.6849C10.2121 24.5766 10.2264 28.7912 12.4908 30.0986C14.7552 31.406 18.4123 29.311 20.6592 25.4193Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5412 43.2492C53.7881 39.3575 53.7738 35.1428 51.5094 33.8354C49.245 32.5281 45.5879 34.6231 43.341 38.5148C41.0941 42.4065 41.1083 46.6211 43.3728 47.9285C45.6372 49.2359 49.2943 47.1409 51.5412 43.2492Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6274 47.9283C22.8918 46.6209 22.9061 42.4062 20.6592 38.5145C18.4123 34.6228 14.7552 32.5278 12.4908 33.8352C10.2264 35.1426 10.2121 39.3572 12.459 43.2489C14.7059 47.1406 18.363 49.2356 20.6274 47.9283Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5092 30.0988C53.7737 28.7914 53.7879 24.5767 51.541 20.685C49.2941 16.7933 45.637 14.6983 43.3726 16.0057C41.1082 17.3131 41.0939 21.5277 43.3408 25.4194C45.5877 29.3111 49.2448 31.4061 51.5092 30.0988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/DOT.fb16f7a9292f3d36b8720e91981a5722.svg";
export { ForwardRef as ReactComponent };